import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { PartnerOfferingPanelProps } from './types';
import { styles } from './styles';
import { Button, CollapsiblePanel } from '@v2/components';
import PartnerOffering from '../PartnerOffering';

const PartnerOfferingPanel: React.FC<PartnerOfferingPanelProps> = ({
  offerings,
  partnerId: _partnerId,
  onEditOffering,
  onAddOffering,
}) => {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const handleAddOffering = () => {
    onAddOffering?.();
  };

  const handleChipClick = (key: string) => {
    setActiveKey(key || null);
  };

  return (
    <CollapsiblePanel title={`Offerings (${offerings.length})`} defaultExpanded={false}>
      <div className={styles.header}>
        <span className={styles.title}>
          {offerings.length > 0
            ? `${offerings.length} ${offerings.length === 1 ? 'offering' : 'offerings'}`
            : 'No offerings for this partner'}
        </span>
        <Button
          variant="ghost-success"
          size="sm"
          onClick={handleAddOffering}
          icon={<FontAwesomeIcon icon={faPlus} />}>
          Add Offerings
        </Button>
      </div>
      {offerings.length > 0 && (
        <div className={styles.grid}>
          {offerings.map(offering => (
            <PartnerOffering
              key={offering.id}
              offering={offering}
              activeKey={activeKey}
              onChipClick={handleChipClick}
              onEdit={onEditOffering}
            />
          ))}
        </div>
      )}
    </CollapsiblePanel>
  );
};

export default PartnerOfferingPanel;
